import React, { useEffect, useState } from 'react'
import { APP_ROUTES } from "constants/AppRoutes";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { ListGroup } from 'react-bootstrap';
import { Button } from 'primereact/button';
//icons
import { BsArrowRight } from "react-icons/bs";
import { RiFileExcel2Line } from 'react-icons/ri';
//components
import CustomizeReport from 'pages/Reports/CustomizeReport/CustomizeReport';
import InformationBox from 'components/common/Message/InformationBox/InformationBox';
import Breadcrumb from "components/common/Breadcrumb/Breadcrumb";
import ReportViewer from 'components/common/Report/ReportViewer'
//redux
import { onExportReport, setIsAppliedDone } from 'redux/common/report/customizeReportSlice';
import { getStatusList } from 'redux/pages/Administration/administrationSlice';
import { getAllBranchOfficeList } from 'redux/pages/Manage/OrganizationSettings/branchOfficeSlice';
import { useAppSelector } from "../../redux/hooks";
import { createReportPreviewSession, setReportPreviewSession } from "../../redux/pages/Administration/Site/siteSlice";
import { useDispatch } from "react-redux";

type FormData = {
	branchId: string;
	statusId: number;
};

const ContractsReport = () => {

	const {
		control,
	} = useForm<FormData>({
		defaultValues: {
			branchId: "",
			statusId: 0,
		},
	});

	const [reportName, setReportName] = useState<any>(null);
	const [selectedStatus, setSelectedStatus] = useState<number>(0);
	const [selectedBranch, setSelectedBranch] = useState<any>('all');
	const [statusList, setStatusList] = useState<any>([]);
	const [showCustomizeReport, setShowCustomizeReport] = useState(false);
	const [displayInfoModal, setDisplayInfoModal] = useState(false);
    const [message, setMessage] = useState<string>("");
	const [customizationType, setCustomizationType] = useState('user');

	const reportPreviewSession = useAppSelector((state) => state.site.reportPreviewSession);
	const { status } = useAppSelector((state) => state.administration.statusList);
	const branchOfficeList = useAppSelector((state) => state.branchOffice.allBranchOfficeList);
	const isAppliedDone = useAppSelector((state) => state.customizeReport.isAppliedDone);
	const navigate = useNavigate();
	const dispatch = useDispatch<any>();

	useEffect(() => {
		dispatch(getStatusList());
		dispatch(getAllBranchOfficeList());
	}, []);

	useEffect(() => {
		if (status && status.length) {
			let tempList = [{ statusId: 0, statusCode: "All_Users", statusName: "All" },
			...status.filter(status => [1, 3].includes(status.statusId))]
			setStatusList(tempList);
		}
	}, [status]);

	const viewContractReport = () => {
		const reportParameters = {
			reportParameters: {
				uniqueBranchOfficeId: selectedBranch === 'all' ? "" : selectedBranch,
				statusId: selectedStatus,
				customizationType: customizationType
			},
			reportType: "Contract List Report"
		};
		dispatch(createReportPreviewSession(reportParameters));
	};

	useEffect(() => {
		viewContractReport();
		
		return (() => {
			dispatch(setReportPreviewSession(""));
		})
	}, [selectedStatus, selectedBranch]);

	useEffect(() => {
		if(isAppliedDone) viewContractReport();
	}, [isAppliedDone])

	useEffect(() => {
		if (isAppliedDone) {
			dispatch(setIsAppliedDone(false));
			setShowCustomizeReport(false);
			setMessage("Report settings saved");
			setDisplayInfoModal(true);
		}
	}, [isAppliedDone])

	useEffect(() => {
		if (reportPreviewSession) {
			setReportName(reportPreviewSession.previewSessionId);
		}
	}, [reportPreviewSession])

	const exportAsExcel = () => {
		const reportParameters = {
			exportParameters: {
				uniqueBranchOfficeId: selectedBranch === 'all' ? "" : selectedBranch,
				statusId: selectedStatus,
				customizationType: customizationType
			},
			exportType: "Contract List Report"
		};
		dispatch(onExportReport(reportParameters, "Contracts"));
	};

	return (

		<div className='site-reports site-report-dropdown'>
			<section className="d-flex align-items-center">
				<Breadcrumb
					title="Reports"
					classNames="report-header"
					handleGoBackClick={() => navigate(`/${APP_ROUTES.REPORT_VIEW}`)}
				/>
				<div className="breadcrumb-right-arrow ml-3 mr-3">
					<BsArrowRight className="icon" />
				</div>
				<div className="breadcrumb-sub-page-title">
					<span>Contracts</span>
				</div>
			</section>

			<div className="report-sort-field pt-2 pb-2">
				<div className="report-export-main d-flex">
					<div className="row px-2">
						<div className="report-field col-12 md:col-2">
							<div className="field  mb-0">
								<span className="p-float-label">
									<Controller
										name="statusId"
										control={control}
										render={({ field, fieldState }) => (
											<Dropdown
												inputId="statusDropdown"
												className={classNames("w-100 error-tooltip", {
													error: fieldState.invalid,
												})}
												{...field}
												value={selectedStatus}
												onChange={(e) => {
													setSelectedStatus(e.value);
												}}
												options={statusList}
												optionLabel="statusName"
												optionValue="statusId"
											/>
										)}
									/>
									<label htmlFor="statusDropdown">Status</label>
								</span>
							</div>
						</div>
						<div className="report-field col-12 md:col-2">
							<div className="field  mb-0">
								<span className="p-float-label">
									<Controller
										name="branchId"
										control={control}
										render={({ field, fieldState }) => (
											<Dropdown
												inputId="dropdown"
												className={classNames("w-100 error-tooltip", {
													error: fieldState.invalid,
												})}
												{...field}
												value={selectedBranch}
												onChange={(e) => {
													setSelectedBranch(e.value);
												}}
												options={[{ uniqueBranchOfficeId: "all", name: "All" }, ...branchOfficeList]}
												optionLabel="name"
												optionValue="uniqueBranchOfficeId"
											/>
										)}
									/>
									<label htmlFor="dropdown">Branch</label>
								</span>
							</div>
						</div>
					</div>
					<div className="report-buttons-main d-flex">

						<div className="report-buttons">
							<ListGroup horizontal>
								<ListGroup.Item><Button label="Customize" className="report-btn" onClick={() => setShowCustomizeReport(true)} /></ListGroup.Item>
							</ListGroup>
						</div>
						<div className='export-report-buttons'>
							<ListGroup horizontal>
								<span className='expor-title'>Export to</span>
								<ListGroup.Item>
									<Button className="export-btn" onClick={() => exportAsExcel()}> <RiFileExcel2Line className="icon" /> Excel </Button>
								</ListGroup.Item>
								{/* <ListGroup.Item>
									<Button className="export-btn"> <BsFileEarmarkPdf className="icon" /> PDF </Button>
								</ListGroup.Item>
								<ListGroup.Item>
									<Button className="export-btn"> <GrDocumentRtf className="icon" /> RTF </Button>
								</ListGroup.Item>
								<ListGroup.Item>
									<Button className="export-btn"> <AiOutlineFileText className="icon" /> Text </Button>
								</ListGroup.Item> */}
							</ListGroup>
						</div>
					</div>
				</div>
			</div>
			<InformationBox
				showInfoModal={displayInfoModal}
				setShowInfoModal={setDisplayInfoModal}
				message={message}
			/>
			{showCustomizeReport &&
				<CustomizeReport
					reportType="CONTRACT_LIST_REPORT"
					showModal={showCustomizeReport}
					onHideModal={() => setShowCustomizeReport(false)}
					customizationType={customizationType}
					setCustomizationType={setCustomizationType} />
			}

			<ReportViewer reportId={reportName} />
		</div>
	)
}

export default ContractsReport;